import { load } from 'recaptcha-v3';

class Recaptcha3 {
  static async getSubmitToken() {
    const recaptcha = await load('6LfVY3khAAAAAG5AJh9Ej44_jy6sDNz56H1o_Ibv');
    const token = await recaptcha.execute('submit');

    return token;
  }
}

export default Recaptcha3;
